import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { StatusChip } from './StatusChip';
import { statusToneDotClass, type StatusTone } from './StatusBadgeTone';

const TONE_CLASSES: Record<StatusTone, string> = {
  draft: 'bg-muted text-muted-foreground',
  pending: 'bg-warning-surface text-warning',
  approved: 'bg-success-surface text-success',
  declined: 'bg-muted text-muted-foreground',
  void: 'bg-muted text-muted-foreground opacity-70',
  paid: 'bg-success-surface text-success',
  danger: 'bg-destructive-surface text-destructive',
};

type FinancialStatusBadgeProps = {
  tone: StatusTone;
  label: string;
  status?: never;
  className?: never;
  color?: never;
};

type LegacyStatusBadgeProps = {
  className?: string;
  color?: string;
  label?: string;
  status: string;
  tone?: never;
};

function isFinancialStatusBadgeProps(
  props: FinancialStatusBadgeProps | LegacyStatusBadgeProps,
): props is FinancialStatusBadgeProps {
  return props.tone !== undefined;
}

export function StatusBadge(props: FinancialStatusBadgeProps | LegacyStatusBadgeProps) {
  if (!isFinancialStatusBadgeProps(props)) {
    return (
      <StatusChip
        className={props.className}
        color={props.color}
        label={props.label}
        status={props.status}
        variant="dot"
      />
    );
  }

  const { tone, label } = props;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
        TONE_CLASSES[tone],
      )}
    >
      {tone === 'approved' || tone === 'paid' ? (
        <Check className="size-3" />
      ) : (
        <span className={cn('size-2 rounded-full', statusToneDotClass(tone))} />
      )}
      {label}
    </span>
  );
}
